// Keep the anatomy illustration and its corresponding signals color matched.
export const ECG_COLOR = [46, 255, 83];
export const RESP_COLOR = [255, 232, 75];
